import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

interface ViewSettings {
  type: number;
  isHideFrisbuyIcon: boolean;
  trigger?: string;
  placement?: string;
  openDelay?: number;
  closeDelay?: number;
  offset?: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SumSection',
  props: {
    isBordered: { type: Boolean },
    viewSettings: {}
  },
  emits: ["swipeToMarket"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["frisbuy-summary-widget", {
        'frisbuy-summary-widget--bordered': true || props.isBordered,
        'frisbuy-summary-widget--icon-hidden':
          props.viewSettings.isHideFrisbuyIcon,
      }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('swipeToMarket')))
    }, [
      _renderSlot(_ctx.$slots, "arrow"),
      _renderSlot(_ctx.$slots, "header"),
      _renderSlot(_ctx.$slots, "content"),
      _renderSlot(_ctx.$slots, "tags"),
      _renderSlot(_ctx.$slots, "ai-2"),
      _renderSlot(_ctx.$slots, "logo")
    ], 2)
  ]))
}
}

})